import http from '@/utils/services/http'

export default {
  listar () {
    return http.get('/api/trabalhe-conosco/')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getDetalhes (id) {
    return http.get('/api/trabalhe-conosco/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deletar (id) {
    return http.delete('/api/trabalhe-conosco/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/trabalhe-conosco/services/trabalhe-conosco.js